export default __webpack_public_path__ + "static/media/ST1_DEEP_MOIST_550_D.fc3c7e36.e3c2fa75.png";